import h from 'virtual-dom/h';
import {DefaultSettings} from '../../../../settings/settings-util';
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {VChild} from "virtual-dom";
import {Dictionary, Mutator} from "../../../../types/rendering";
import {HistoryMessage} from "../../../../types/history";


type MessageRenderer = (message: HistoryMessage) => VChild;
type ChildRenderer = () => VChild;


export default class Renderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _mutators: Mutator[] = [];
    _messageRenderers: MessageRenderer[] = [];
    _preChildRenderers: ChildRenderer[] = [];
    _postChildRenderers: ChildRenderer[] = [];


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>,
               messageRenderers: MessageRenderer[],
               mutators: Mutator[],
               preChildRenderers: ChildRenderer[],
               postChildRenderers: ChildRenderer[] = []): void
    {
        this._store = store;
        this._mutators = mutators;
        this._messageRenderers = messageRenderers;
        this._preChildRenderers = preChildRenderers;
        this._postChildRenderers = postChildRenderers;
    }
    setAriaHidden()
    {
        let concersationareaelement = document.getElementsByClassName(`${this._settings.classNames.conversationAreaClassName}`);
        if (concersationareaelement.length > 0) { 
            concersationareaelement[0].setAttribute('aria-hidden', "true");
        }
        let uidragclass = 'ui-draggable-handle';
        let headerelement = document.getElementsByClassName(`${this._settings.classNames.headerClassName}`);
        let headerelementwithdrag = document.getElementsByClassName(`${this._settings.classNames.headerClassName} ${uidragclass}`);
        if (headerelement.length > 0) {
            headerelement[0].setAttribute('aria-hidden', "true");
        }
        else if (headerelementwithdrag.length > 0) {
            headerelementwithdrag[0].setAttribute('aria-hidden', "true");
        }
    }
    removeAriaHidden()
    {
        let concersationareaelement = document.getElementsByClassName(`${this._settings.classNames.conversationAreaClassName}`);
        if (concersationareaelement.length > 0) { 
            concersationareaelement[0].removeAttribute('aria-hidden');
        }
        let uidragclass = 'ui-draggable-handle';
        let headerelement = document.getElementsByClassName(`${this._settings.classNames.headerClassName}`);
        let headerelementwithdrag = document.getElementsByClassName(`${this._settings.classNames.headerClassName} ${uidragclass}`);
        if (headerelement.length > 0) {
            headerelement[0].removeAttribute('aria-hidden');
        }
        else if (headerelementwithdrag.length > 0) {
            headerelementwithdrag[0].removeAttribute('aria-hidden')
        }
    }
    getMinimizeState(): boolean{
            const windowBaseLoc = this._settings.stateLocations.Window.Base;
            const isInputBoxLockedLocation = this._settings.stateLocations.Window.IsMinimized;

            if (windowBaseLoc && isInputBoxLockedLocation) {
                return this._store?.getState()[windowBaseLoc][isInputBoxLockedLocation] || false;
            }
      return false;
    }
    getRender(): () => VChild
    {
        return (): VChild =>
        {
            const { conversationHistoryLabel, conversationHistoryLive } = this._settings.accessibility.aria;
            const { Base, Messages } = this._settings.stateLocations.History;
            const messages = this._store?.getState()[Base][Messages] as HistoryMessage[];
            if(this.getMinimizeState())
            {
                this.setAriaHidden();
            }
            else
            {
                this.removeAriaHidden();
            }
            let parameters: Dictionary = {
                className : this._settings.classNames.conversationAreaClassName,
                attributes: {
                  role: 'log',
                  'aria-label': conversationHistoryLabel,
                  'aria-live' : conversationHistoryLive,
                },
            };

            parameters = this._mutators.reduce((currentParams, mutate) => mutate(currentParams), parameters);

            const messageNodes = messages.flatMap(message => this._messageRenderers.map(render => render(message)));
            const preChildNodes = this._preChildRenderers.map(render => render());
            const postChildNodes = this._postChildRenderers.map(render => render());

            return h('div', parameters, [...preChildNodes, ...messageNodes, ...postChildNodes]);
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-conversationarea/src/renderers/renderer.ts